export default __webpack_public_path__ + "static/media/filter-solid.7127ee88.svg";